import { createFileRoute } from '@tanstack/react-router';
import NewsEntryCreate from '~/containers/NewsEntryCreate';

export const Route = createFileRoute('/news-entries/create')({
  component: NewsEntryCreate,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
